export class Reward {
  constructor(days, title, emoji, description) {
    this.id = Date.now();
    this.days = days;
    this.title = title;
    this.description = description;
    this.emoji = emoji;
  }
}
